import ApiService from "../ApiService";

const calendarService = {
  getAllowedDates(branch,city) {
    return ApiService.customRequest({
      url: `${ApiService.farmadomiciliosApiURL}/calendar-configuration/getAllowedDates/${branch}/${city}`,
      method: "GET"
    });
  }
};

export default calendarService;
